import { z } from '../../../zod';

const CheckoutAbandonmentReminderValidationSchema = z.object({
  customizeEmail: z.boolean().meta({
    description: 'Enable a custom email for this reminder.',
    example: true,
  }),
  subject: z.string().optional().meta({
    description: 'Email subject line.',
    example: 'Complete your purchase',
  }),
  body: z.string().optional().meta({
    description:
      'Email body. Accepts HTML or plain text. Takes the same `{{id}}` variables as `confirmationEmailMessage`, except `amountDue`, `amountPaid`, `currentPeriodEnd`, `status`, `payment_method` and `customer_portal_link`: the customer has not paid yet.',
    example: '<p>You left something behind!</p>',
  }),
  buttonText: z.string().optional().meta({
    description: 'Email call-to-action button label.',
    example: 'Complete order',
  }),
});

export const PageCheckoutAbandonmentSettingsInputValidationSchema = z
  .object({
    disableEmails: z.boolean().nullish().meta({
      description:
        'Disable automatic abandoned checkout follow-up emails for this page. Store-level settings may override this. [Learn more](https://checkoutpage.com/docs/articles/cart-abandonment)',
      example: false,
    }),
    showStoreLogo: z.boolean().nullish().meta({
      description: 'Show store logo in cart abandonment email.',
      example: true,
    }),
    showStoreName: z.boolean().nullish().meta({
      description: 'Show store name in cart abandonment email.',
      example: true,
    }),
    emailReminders: z
      .object({
        reminder1: CheckoutAbandonmentReminderValidationSchema.nullish(),
        reminder2: CheckoutAbandonmentReminderValidationSchema.nullish(),
        reminder3: CheckoutAbandonmentReminderValidationSchema.nullish(),
      })
      .nullish()
      .meta({
        description:
          'Customize the subject, body, and button text for each of the three abandonment reminder emails.',
      }),
  })
  .meta({
    id: 'PageCheckoutAbandonmentSettingsInput',
    description: 'Cart abandonment configuration.',
    example: {
      disableEmails: false,
      showStoreLogo: true,
      showStoreName: true,
      emailReminders: {
        reminder1: {
          customizeEmail: true,
          subject: 'You left something behind',
          body: '<p>Come back and complete your order.</p>',
          buttonText: 'Complete order',
        },
      },
    },
  });

export const CheckoutAbandonmentResponseValidationSchema = z.object({
  disableEmails: z.boolean().optional(),
  showStoreLogo: z.boolean().optional(),
  showStoreName: z.boolean().optional(),
  emailReminders: z
    .record(
      z.string(),
      z
        .object({
          customizeEmail: z.boolean(),
          subject: z.string().optional(),
          body: z.string().optional(),
          buttonText: z.string().optional(),
        })
        .optional(),
    )
    .optional(),
});
